import React from "react";

const Skeleton = ({ lines = 3 }) => {
  return (
    <div className="skeleton">
      {Array.from({ length: lines }, (_, i) => (
        <div className="skeleton__line" key={i} />
      ))}
    </div>
  );
};

export default Skeleton;
